module.exports = __webpack_public_path__ + "static/media/01.bd23c91c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/makeup/01.png
// module id = 634
// module chunks = 0